
import React from "react";
import { useTheme } from "@material-ui/core";
import HvIconBase from "./IconBase";

const sizeSelector = (iconSize, height, width) => {
  if (height && width) {
    return { width, height };
  }

  switch (iconSize) {
    case "XS":
      return { width: 12, height: 12 };
    default:
    case "S":
      return { width: 16, height: 16 };
    case "M":
      return { width: 32, height: 32 };
    case "L":
      return { width: 96, height: 96 };
  }
};

const LightShowerNight = ({
  color,
  iconSize = "S",
  viewbox = "0 0 16 16",
  height,
  width,
  semantic,
  inverted = false,
  svgProps,
  ...others
}) => {
  const theme = useTheme();
  const getColor = c => theme.palette?.[c] || c;
  const colorArray = 
    (typeof color === "string" && [getColor(color)]) ||
    (Array.isArray(color) && color.map?.(getColor)) ||
    [theme.palette.acce1];

  if (semantic) {
    colorArray[0] = theme.palette?.[semantic] || colorArray[0];
  }

  if (inverted && colorArray[1]) {
    colorArray[1] = colorArray[0];
    colorArray[0] = "none";
  }

  const size = sizeSelector(iconSize, height, width);

  return (
    <HvIconBase name="LightShowerNight" iconSize={iconSize ?? "S"} {...others}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewbox} height={size.height} width={size.width}   focusable={false} {...svgProps}>
  <path fill={colorArray[0]} className="color0"  d="M6.791 13.86l.969.243.243-.975-.97-.245-.242.977zm.484-1.953l.97.243.242-.976-.969-.244-.243.977zm-.969 3.898l.983.195.229-.919-.97-.244-.242.968zm4.181-4.631l-.97-.244-.242.977.97.243.242-.976zm-5.431.733l.969.243.242-.976-.97-.244-.241.977z" />
  <path fill={colorArray[0]} className="color0"  d="M13.616 9.312A5.011 5.011 0 0016 5.493a3.985 3.985 0 01-5.454-1.507 4.053 4.053 0 010-3.986 5.021 5.021 0 00-4.52 5.011H6a4.005 4.005 0 00-3.9 3.161 3.022 3.022 0 00.9 5.9h1.518l-.069.276.969.245.243-.977L5 13.451v-.386H3a2.015 2.015 0 01-.6-3.933l.551-.176.124-.568A3.022 3.022 0 016 6.018c.044 0 .085.014.128.016A3.058 3.058 0 018.5 7.369l.5.757.8-.426a1.487 1.487 0 012.018.626 1.513 1.513 0 01.168.577c0 .044.014.087.014.133v.024l-.025.847.089.018.736.15a1.511 1.511 0 01-.3 2.99H9.766l-.161.482-.694-.174-.242.975.97.245.129-.521H12.5a2.514 2.514 0 001.115-4.76zm-.671-.785a2.489 2.489 0 00-3.61-1.715 4 4 0 00-2.3-1.662c0-.047-.014-.091-.014-.139a4.033 4.033 0 012.022-3.5c-.015.159-.023.32-.023.481a5.022 5.022 0 005 5.034c.161 0 .321-.008.478-.023a3.826 3.826 0 01-1.553 1.524z" />
</svg>
    </HvIconBase>
)};

LightShowerNight.propTypes = HvIconBase.propTypes;

export default LightShowerNight;